import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { CommercialCompetenceService } from '../../services/commercial-competence.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';


export interface SerasaModal {
  pendencia:any;
  objSerasa: any;
  proposalID: any;
  clientID: any;

}

@Component({
  selector: 'app-cc-serasa-modal',
  templateUrl: './cc-serasa-modal.component.html',
  styleUrls: ['./cc-serasa-modal.component.scss'],
  providers:[CommercialCompetenceService]
})

export class CcSerasaModalComponent extends DialogComponent<SerasaModal, boolean> implements SerasaModal {

  pendencia: any;
  objSerasa: any;
  proposalID: any;
  clientID: any;

  constructor(dialogService: DialogService,
              private commercialCompetenceService: CommercialCompetenceService,
              private flashMessagesService: FlashMessagesService,
              private router: Router) {
    super(dialogService);
  }

  sendToCredit(){
    this.commercialCompetenceService.sendProposalToCredit(this.objSerasa).subscribe(result => {
			if (result.Success) {
        this.flashMessagesService.show("Proposta de Alçada Comercial enviada ao Crédito!", { cssClass: 'alert-success', timeout: 6000 });
        this.close();
        this.reloadClient(true);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
  }



  cancelProposal(){
    this.commercialCompetenceService.cancelProposal(this.proposalID).subscribe(result => {
			if (result.Success) {
        this.flashMessagesService.show("Proposta de Alçada Comercial Encerrada!", { cssClass: 'alert-success', timeout: 6000 });
        this.close();
        this.reloadClient(false);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});

  }

  reloadClient(proposal) {
    const propostaLc = proposal?'proposta-alcada':''

		this.router.navigateByUrl('/').then(
			() => {
				this.router.navigateByUrl('/conta-cliente/detalhe/' + this.clientID + "/" + propostaLc);
			});
	}
  
  confirm() {
    this.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/commercial-competence/commercial-competence/cc-serasa-modal/cc-serasa-modal.component.ts